import { isoToEU } from "../../lib/format";

const ADDON_LABELS = {
  gps: "GPS Navigation",
  child_seat: "Child Seat",
  insurance: "Full Insurance",
  additional_driver: "Additional Driver",
};

/**
 * Read-only summary of a booking — vehicle snapshot, pickup/return,
 * driver, license, and selected addons.
 */
export default function VehicleSnapshot({ b }) {
  const v = b.vehicle_snapshot;
  return (
    <div className="bg-white border border-black/10 p-6 md:p-8" data-testid="booking-summary">
      <div className="flex gap-6 items-start">
        <div className="w-32 h-24 bg-[#EFECE6] overflow-hidden flex-shrink-0">
          <img src={v.image_url} alt={v.name} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1">
          <p className="overline">{v.brand}</p>
          <p className="font-display text-2xl mt-1">{v.name}</p>
          <p className="text-xs text-neutral-500 mt-2">{v.category} · {v.seats} seats · {v.transmission}</p>
        </div>
      </div>

      <div className="divider-line my-6"></div>

      <div className="grid grid-cols-2 gap-6 text-sm">
        <div>
          <p className="overline mb-1">Pickup</p>
          <p>{isoToEU(b.pickup_date)}{b.pickup_time ? ` · ${b.pickup_time}` : ""}</p>
          <p className="text-neutral-500">{b.pickup_location}</p>
        </div>
        <div>
          <p className="overline mb-1">Return</p>
          <p>{isoToEU(b.return_date)}{b.return_time ? ` · ${b.return_time}` : ""}</p>
          <p className="text-neutral-500">{b.return_location}</p>
        </div>
        <div>
          <p className="overline mb-1">Driver</p>
          <p>{b.full_name}</p>
          <p className="text-neutral-500">{b.phone}</p>
        </div>
        <div>
          <p className="overline mb-1">License</p>
          <p>{b.license_number}</p>
        </div>
      </div>

      {b.addons?.length > 0 && (
        <>
          <div className="divider-line my-6"></div>
          <p className="overline mb-3">Add-ons</p>
          <div className="flex flex-wrap gap-2">
            {b.addons.map((a) => (
              <span key={a} className="text-xs px-3 py-1 border border-black/15">
                {ADDON_LABELS[a] || a}
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
